import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useCreatePlanejamentoOperacional() {
  return useMutation(URL.PLANO_OPERACIONAL.CRIAR_PLANEJAMENTO, async (body: any) => {
    const response = await http.post(URL.PLANO_OPERACIONAL.CRIAR_PLANEJAMENTO, body);
    return response;
  });
}

export function useCreatePlanejamentoOperacionalOperacao() {
  return useMutation(async ({ id, body }: { id: string; body: any }) => {
    const response = await http.post(URL.PLANO_OPERACIONAL.CRIAR_PLANEJAMENTO_OPERACAO(id), body);
    return response;
  });
}